(function() {
  const section = document.querySelector('[data-section-type="blog-subpage-grid"]');
  if (!section) return;

  const configEl = section.querySelector('[data-grid-config]');
  const articlesPerPage = parseInt(section.dataset.articlesPerPage, 10) || 13;
  const totalPages = configEl ? parseInt(configEl.dataset.totalPages, 10) || 1 : 1;
  const totalArticles = configEl ? parseInt(configEl.dataset.totalArticles, 10) || 0 : 0;

  const urlParams = new URLSearchParams(window.location.search);
  let currentPage = parseInt(urlParams.get('grid_page'), 10) || 1;
  if (currentPage < 1) currentPage = 1;
  if (currentPage > totalPages) currentPage = totalPages;

  const firstSixGrid = section.querySelector('[data-grid="first-six"]');
  const featuredGrid = section.querySelector('[data-grid="featured"]');
  const lastSixGrid = section.querySelector('[data-grid="last-six"]');
  const prevBtn = section.querySelector('[data-pagination="prev"]');
  const nextBtn = section.querySelector('[data-pagination="next"]');
  const paginationNumbers = section.querySelector('[data-pagination="numbers"]');

  function buildPaginationNumbers(page) {
    if (!paginationNumbers) return;

    paginationNumbers.innerHTML = '';

    const pages = [];

    if (totalPages <= 7) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      pages.push(1);

      if (page <= 3) {
        pages.push(2, 3, 4);
        pages.push('...');
        pages.push(totalPages);
      } else if (page >= totalPages - 2) {
        pages.push('...');
        pages.push(totalPages - 3, totalPages - 2, totalPages - 1, totalPages);
      } else {
        pages.push('...');
        pages.push(page - 1, page, page + 1);
        pages.push('...');
        pages.push(totalPages);
      }
    }

    pages.forEach(p => {
      if (p === '...') {
        const ellipsis = document.createElement('span');
        ellipsis.className = 'pagination__ellipsis';
        ellipsis.textContent = '...';
        paginationNumbers.appendChild(ellipsis);
        return;
      }

      const link = document.createElement('a');
      link.className = 'pagination__number' + (p === page ? ' pagination__number--active' : '');
      link.href = p === 1 ? '?' : `?grid_page=${p}`;
      link.textContent = p;
      link.dataset.page = p;

      link.addEventListener('click', function(e) {
        e.preventDefault();
        currentPage = parseInt(this.dataset.page, 10);
        history.pushState(null, '', currentPage === 1 ? window.location.pathname : `?grid_page=${currentPage}`);
        renderPage(currentPage);
        section.scrollIntoView({ behavior: 'smooth' });
      });

      paginationNumbers.appendChild(link);
    });
  }

  function renderPage(page) {
    if (firstSixGrid) firstSixGrid.innerHTML = '';
    if (featuredGrid) featuredGrid.innerHTML = '';
    if (lastSixGrid) lastSixGrid.innerHTML = '';

    const startIndex = (page - 1) * articlesPerPage;
    const endIndex = startIndex + articlesPerPage;

    for (let i = startIndex; i < endIndex && i < totalArticles; i++) {
      const positionOnPage = i - startIndex;
      const articleEl = section.querySelector(`[data-article-index="${i}"]`);
      const featuredTemplate = section.querySelector(`template[data-featured-index="${i}"]`);

      if (positionOnPage < 6 && articleEl && firstSixGrid) {
        const wrapper = document.createElement('div');
        wrapper.className = 'blog-subpage-grid__item blog-subpage-grid__item--small';
        wrapper.innerHTML = articleEl.innerHTML;
        firstSixGrid.appendChild(wrapper);
      } else if (positionOnPage === 6 && featuredTemplate && featuredGrid) {
        featuredGrid.innerHTML = featuredTemplate.innerHTML;
      } else if (positionOnPage >= 7 && positionOnPage < articlesPerPage && articleEl && lastSixGrid) {
        const wrapper = document.createElement('div');
        wrapper.className = 'blog-subpage-grid__item blog-subpage-grid__item--small';
        wrapper.innerHTML = articleEl.innerHTML;
        lastSixGrid.appendChild(wrapper);
      }
    }

    buildPaginationNumbers(page);

    if (prevBtn) {
      if (page <= 1) {
        prevBtn.classList.add('pagination__arrow--disabled');
      } else {
        prevBtn.classList.remove('pagination__arrow--disabled');
        prevBtn.href = page === 2 ? '?' : `?grid_page=${page - 1}`;
      }
    }

    if (nextBtn) {
      if (page >= totalPages) {
        nextBtn.classList.add('pagination__arrow--disabled');
      } else {
        nextBtn.classList.remove('pagination__arrow--disabled');
        nextBtn.href = `?grid_page=${page + 1}`;
      }
    }
  }

  renderPage(currentPage);

  if (prevBtn) {
    prevBtn.addEventListener('click', function(e) {
      e.preventDefault();
      if (currentPage > 1) {
        currentPage--;
        history.pushState(null, '', currentPage === 1 ? window.location.pathname : `?grid_page=${currentPage}`);
        renderPage(currentPage);
        section.scrollIntoView({ behavior: 'smooth' });
      }
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', function(e) {
      e.preventDefault();
      if (currentPage < totalPages) {
        currentPage++;
        history.pushState(null, '', `?grid_page=${currentPage}`);
        renderPage(currentPage);
        section.scrollIntoView({ behavior: 'smooth' });
      }
    });
  }

  window.addEventListener('popstate', function() {
    const params = new URLSearchParams(window.location.search);
    currentPage = parseInt(params.get('grid_page'), 10) || 1;
    renderPage(currentPage);
  });
})();
